const createId = () => window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
export function getAnalyticsIdentity() {
  let visitorId = localStorage.getItem("flip_visitor_id");
  let sessionId = sessionStorage.getItem("flip_session_id");
  if (!visitorId) { visitorId = createId(); localStorage.setItem("flip_visitor_id", visitorId); }
  if (!sessionId) { sessionId = createId(); sessionStorage.setItem("flip_session_id", sessionId); }
  return { visitorId, sessionId };
}
